.table-search{height:30px;border-radius:28px;width:220px}.dropdown-toggle.active{color:#5930fb;border-color:#5930fb}.converted-by-input,.wider-input{width:300px}
/*# sourceMappingURL=invoices-search.component-BA5YVOO6.css.map */
